export default __webpack_public_path__ + "static/media/male-user-profile-picture.png.b4d1e483.webp";